export default {
    list: () => {
        return axios.get('/api/customer/user/online');
    }
}